<template>
  <div class="integral-brief">
    <div class="integral">
      <div class="left"></div>
      <div class="right"></div>
      <div class="value">85%</div>
    </div>
    <div class="short">
      <span>差{{shortofIntegral}}积分，可升级VIP</span>
    </div>
    <div class="expire-date">
      <span>50积分将于{{expireDate}}过期</span>
    </div>
  </div>
</template>
<script>
import circleProgress from '@components/comm/circle-progress.vue'
export default {
  components: {
			circleProgress,
		},
  props: {
    myIntegral: {
      type: Number,
      default: 0
    },
    shortofIntegral: {
      type: Number,
      default: 0
    },
    expireDate: {
      type: String,
      default: "2019/01/01"
    }
  }
};
</script>

<style lang="scss" scoped>
.integral-brief {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .integral {
    margin: 10px auto;
    width: 8em;
    height: 8em;
    position: relative;
  }
  .integral .value {
    position: absolute;
    width: 6em;
    height: 6em;
    background-color: white;
    border-radius: 50%;
    left: 1em;
    top: 1em;
    line-height: 6em;
    text-align: center;
  }

  .left,
  .right {
    width: 4em;
    height: 8em;
    overflow: hidden;
    position: relative;
    float: left;
    background-color: #999999;
  }

  .left {
    border-radius: 8em 0 0 8em;
  }

  .right {
    border-radius: 0 8em 8em 0;
  }

  .left:after,
  .right:after {
    content: "";
    position: absolute;
    display: block;
    width: 4em;
    height: 8em;
    background-color: white;
    border-radius: 8em 0 0 8em;
    background-color: red;
  }

  .right:after {
    content: "";
    position: absolute;
    display: block;
    border-radius: 0 8em 8em 0;
  }
  .left:after {
    transform-origin: right center;
  }

  .right:after {
    transform-origin: left center;
    transform: rotateZ(45deg);
  }

  .short {
    height: 30px;
    color: black;
  }
  .expire-date {
    height: 30px;
    color: red;
  }
}
</style>
